import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogBody,
} from '@axa-asia/emma-stylesheet/lib/components/Dialog';
import { triggerPopupCloseScreenChange } from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import { isApp, resolveLocalizedText } from '../../../../../utils';
import { setUpIsHKAddressCase } from '../../../actions/changeAddressAction';
import {
  getIsGoogleMapJsScriptComplete,
  getIsHappyHKCase,
} from '../../../selectors/changeAddressSelector';
import { goto } from '../../../../../actions/historyActions';
import { ADDRESS_HK_ENG } from '../../../constants/constants';
import { getErrorCode } from '../../../utils';
import { gaClickAbleElement } from '../../../../../utils/generalGaEventAnalytics';
import './style.scss';
import { EmmaFactory } from '@axa-asia/hk-emma-js';

export interface HappyHKCaseDialogContainerProps {
  hkEngAddress: any;
  isHappyHKCase: boolean;
  isGoogleMapJsScriptError: boolean;
  onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => void;
}

export class HappyHKCaseDialogContainer extends Component<
  HappyHKCaseDialogContainerProps
> {
  onClickSetUpIsHKAddressCase = () => {
    triggerPopupCloseScreenChange();
    this.props.onSetUpIsHKAddressCase(false);
  };

  handleOpenPdfInApp(link: string) {
    if (isApp()) {
      EmmaFactory.createInstance()
        .then((emma) => {
          emma.instance.goTo(`system/open-pdf?pdfUrl=${link}`);
        })
        .catch((e) => {
          console.error('Error in handleOpenPdf', e);
        });
    }
  }

  render() {
    const { hkEngAddress, isHappyHKCase, isGoogleMapJsScriptError } =
      this.props;
    return (
      <div className="happyHkCaseDialog">
        <Dialog show={isHappyHKCase}>
          <DialogHeader>
            {hkEngAddress.title ? resolveLocalizedText(hkEngAddress.title) : ''}
          </DialogHeader>
          <DialogBody>
            <div className="HK-address-modal-content">
              <div className="HK-address-modal-content-item">
                {hkEngAddress.desc
                  ? resolveLocalizedText(hkEngAddress.desc)
                  : ''}
              </div>
              <div className="HK-address-modal-content-item">
                {hkEngAddress.subDesc
                  ? resolveLocalizedText(hkEngAddress.subDesc)
                  : ''}
              </div>
              <div className="HK-address-modal-content-text">
                {hkEngAddress.content
                  ? resolveLocalizedText(hkEngAddress.content)
                  : ''}
              </div>
            </div>
          </DialogBody>
          <DialogFooter>
            <button
              className="emma-stylesheet-primary-default-button"
              onClick={() => {
                gaClickAbleElement(
                  hkEngAddress.buttons &&
                    hkEngAddress.buttons[0] &&
                    hkEngAddress.buttons[0].label
                    ? resolveLocalizedText(hkEngAddress.buttons[0].label)
                    : '',
                  'HappyHKCase',
                );
                this.onClickSetUpIsHKAddressCase();
              }}
            >
              {hkEngAddress.buttons &&
              hkEngAddress.buttons[0] &&
              hkEngAddress.buttons[0].label
                ? resolveLocalizedText(hkEngAddress.buttons[0].label)
                : ''}
            </button>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={hkEngAddress.buttons[1].deepLink.query.url}
              onClick={(e) => {
                if (isApp()) {
                  e.preventDefault();
                }
              }}
            >
              <button
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  this.handleOpenPdfInApp(
                    hkEngAddress.buttons[1].deepLink.query.url,
                  );
                  gaClickAbleElement(
                    hkEngAddress.buttons &&
                      hkEngAddress.buttons[1] &&
                      hkEngAddress.buttons[1].label
                      ? resolveLocalizedText(hkEngAddress.buttons[1].label)
                      : '',
                    'HappyHKCase',
                  );
                }}
              >
                {hkEngAddress.buttons &&
                hkEngAddress.buttons[1] &&
                hkEngAddress.buttons[1].label
                  ? resolveLocalizedText(hkEngAddress.buttons[1].label)
                  : ''}
              </button>
            </a>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const hkEngAddress = getErrorCode(ADDRESS_HK_ENG, state);
    return {
      hkEngAddress,
      isHappyHKCase: getIsHappyHKCase(state),
      isGoogleMapJsScriptComplete: getIsGoogleMapJsScriptComplete(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => {
        dispatch(setUpIsHKAddressCase(isHappyHKCase));
      },
    };
  }
}

export default connect(
  HappyHKCaseDialogContainer.mapStateToProps,
  HappyHKCaseDialogContainer.mapDispatchToProps,
)(HappyHKCaseDialogContainer);
